import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightRegistrationModalOpenedEventName = 'FREIGHT_REGISTRATION_MODAL_OPENED';

export type FreightRegistrationModalSource = 'chooser' | 'settings-register';

export const useTrackFreightRegistrationModalOpened = (): ((source: FreightRegistrationModalSource) => void) => {
  return useCallback((source: FreightRegistrationModalSource) => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightRegistrationModalOpenedEventName, { env: environment, source });
  }, []);
};
